import ngCookies from 'angular-cookies';

import { DataServiceModule } from 'services/data/data.service';
import { AppSettingsModule } from 'services/settings.provider';

export const PaymentServiceModule = angular
    .module('app.services.payment.paymentService', [
        ngCookies,
        DataServiceModule,
        AppSettingsModule
    ]).service('paymentService', (
        $http,
        $location,
        $window,
        dataService,
        settings
    ) => {
        let Stripe = {
            requestAuthorization(queryStrings) {
                return $http.get(`${process.env.BASE_API_URL}/store/paymentkeys`).then((stripeData) => {
                    var optArray = [];

                    var options = {
                        response_type: 'code',
                        client_id: stripeData.data.stripePlatformClientId,
                        stripe_landing: 'login',
                        scope: 'read_write',
                        redirect_uri: queryStrings ? `${$location.absUrl()}?${queryStrings}` : $location.absUrl()
                    };

                    Object.keys(options).forEach((key) => {
                        optArray.push(`${key}=${options[key]}`);
                    });

                    optArray = optArray.join('&');

                    let url = `https://connect.stripe.com/oauth/authorize?${optArray}`;
                    $window.location.href = url;
                });
            },

            connectAccount(code) {
                return dataService.create(settings.api.stripe, {
                    stripeAuthorizationCode: code
                });
            },

            disconnectAccount() {
                return dataService.remove(settings.api.stripe);
            },

            isConnectedComplete(storeInfo) {
                return storeInfo.stripeAccountStatus === 'Activated'
                    && storeInfo.stripeAccountId;
            },

            isConnectedPending(storeInfo) {
                return storeInfo.stripeAccountStatus === 'Pending'
                    && storeInfo.stripeAccountId;
            },

            validateCoupon(coupon) {
                return dataService.get(settings.api.validateStripeCoupon, volCouponMapping(coupon));
            }
        };

        function volCouponMapping(coupon) {
            const valid = /^VOL[0-9]{1,6}$/.test(coupon);
            return valid ? 'VOL-SLM1' : coupon;
        }

        return {
            stripe: Stripe
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/payment/payment.service.js